if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.setupOkodokoGalleryArrows();
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      setupOkodokoGalleryArrows() {
        const arrowControls = this.elements.viewer.querySelector('.okodoko-gallery-arrows');
        if (!arrowControls) return;

        arrowControls.querySelectorAll('button[name="previous"], button[name="next"]').forEach((button) => {
          button.removeAttribute('disabled');
          button.addEventListener(
            'click',
            (event) => {
              event.preventDefault();
              event.stopImmediatePropagation();
              this.moveOkodokoGallery(button.name === 'next' ? 1 : -1);
            },
            true
          );
        });
      }

      moveOkodokoGallery(direction) {
        if (this.elements.thumbnails) {
          const thumbnailItems = Array.from(this.elements.thumbnails.querySelectorAll('[data-target]')).filter((item) =>
            this.elements.viewer.querySelector(`[data-media-id="${item.dataset.target}"]`)
          );
          const activeThumbnail = this.elements.thumbnails.querySelector('button[aria-current="true"]')?.closest('[data-target]');

          if (thumbnailItems.length > 1 && activeThumbnail) {
            const activeThumbnailIndex = thumbnailItems.indexOf(activeThumbnail);
            const nextThumbnailIndex = (activeThumbnailIndex + direction + thumbnailItems.length) % thumbnailItems.length;
            const nextTarget = thumbnailItems[nextThumbnailIndex].dataset.target;
            this.setActiveMedia(nextTarget, false);
            return;
          }
        }

        const mediaItems = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]')).filter(
          (item) => !item.classList.contains('product__media-item--variant') || item.classList.contains('is-active')
        );
        if (mediaItems.length < 2) return;

        const activeIndex = Math.max(
          0,
          mediaItems.findIndex((item) => item.classList.contains('is-active'))
        );
        const nextIndex = (activeIndex + direction + mediaItems.length) % mediaItems.length;
        this.setActiveMedia(mediaItems[nextIndex].dataset.mediaId, false);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        const quickAddModal = this.closest('quick-add-modal');
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (quickAddModal) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, top: 0 });
            return;
          }
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
